import { renderPage } from "renderPage"
import { ClubHomeLandingPage } from "./Page"

renderPage({ component: ClubHomeLandingPage })
